import React from 'react';
export function DetailPageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-2234">
      {/* Back button and actions */}
      <div className="flex items-center justify-between" data-id="element-2235">
        <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-2236" />
        <div className="h-10 w-28 bg-gray-200 rounded-md" data-id="element-2237" />
      </div>
      {/* Main info card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2238">
        <div className="flex items-start gap-4 mb-6" data-id="element-2239">
          <div className="w-16 h-16 bg-gray-200 rounded-full" data-id="element-2240" />
          <div className="flex-1" data-id="element-2241">
            <div className="h-8 w-64 bg-gray-200 rounded mb-3" data-id="element-2242" />
            <div className="space-y-2" data-id="element-2243">
              <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-2244" />
              <div className="h-4 w-40 bg-gray-200 rounded" data-id="element-2245" />
              <div className="h-4 w-56 bg-gray-200 rounded" data-id="element-2246" />
            </div>
          </div>
          <div className="h-6 w-20 bg-gray-200 rounded-full" data-id="element-2247" />
        </div>
        {/* Stats */}
        <div className="pt-6 border-t border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2248">
          {[1, 2, 3].map(i => <div key={i} data-id="element-2249">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2" data-id="element-2250" />
              <div className="h-8 w-32 bg-gray-200 rounded" data-id="element-2251" />
            </div>)}
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-2252">
        <div className="border-b border-gray-200 flex gap-8 px-6" data-id="element-2253">
          {[1, 2, 3].map(i => <div key={i} className="py-4" data-id="element-2254">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-2255" />
            </div>)}
        </div>
        {/* Tab content */}
        <div className="p-6 space-y-4" data-id="element-2256">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="border border-gray-200 rounded-lg p-4" data-id="element-2257">
              <div className="flex justify-between items-center" data-id="element-2258">
                <div className="flex-1 space-y-2" data-id="element-2259">
                  <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-2260" />
                  <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-2261" />
                </div>
                <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-2262" />
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}